import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container mt-4" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-12 d-flex flex-column gap-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "text-center mb-4" }, " New Claim Submission ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, " Please review your mailing address and/or payment destination below. Please note: Updating mailing address below will update your primary address on file with the Fund Office for all your correspondences. Updating direct deposit information below will update the payment setup on file with the Fund Office for all your payments (Claims and other Benefits – if applicable). ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", null, [
          _createVNode(_component_router_link, {
            class: "btn btn-secondary",
            to: { name: 'participant.claims' }
          }, {
            default: _withCtx(() => [
              _createTextVNode("Back")
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ])
    ])
  ]))
}